import React, { useContext, useState, useEffect, useRef } from 'react'
import { Input, Form } from 'antd'

const EditableContext = React.createContext(null)

export const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm()
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} className={props.className || 'editable-row'} />
      </EditableContext.Provider>
    </Form>
  )
}

interface Item {
  key: string
  name: string
  age: string
  address: string
}

interface EditableCellProps {
  title: React.ReactNode
  editable: boolean
  editableSalary: boolean
  children: React.ReactNode
  dataIndex: keyof Item
  record: Item,
  rules: Object,
  readOnly: boolean,
  disabled: boolean,
  placeholder: string,
  // handleInputChange: (record: Item, dataIndex: string) => void
  handleSave: (record: Item) => void
}

const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  editableSalary,
  children,
  dataIndex,
  record,
  rules,
  readOnly,
  disabled,
  handleSave,
  handleInputChange,
  placeholder,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false)
  const inputRef = useRef<typeof Input>(null)
  const [value, setValue] = useState('')
  const form = useContext(EditableContext)
  const specialCharRegexRu = new RegExp('[а-яА-ЯЁё!@-]')
  const specialCharRegex = new RegExp(
    /[`~!@#$%^&*_|«»+\-=?;:'"<>\{\}\[\]\\\/]/gi
  )
  const MAX_VAL = 999999999;
  const withValueCap = (inputObj: any) => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return true;
    return false;
  };

  const onKeyPress = (e: React.KeyboardEvent, dataIndex: string) => {
    const specialCharRegex = new RegExp("[a-zA-Z0-9əöüıİçşğƏÖÜIiĞÇŞ.' ,-]");
    const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (dataIndex == 'description') {
      if (!specialCharRegex.test(pressedKey)) {
        e.preventDefault();
        return false;
      }
    }
    if (dataIndex == "amount") {
      // const strAfterDot = e.target.value.split('.', 2)[1]
      // if ((strAfterDot && strAfterDot.length > 1) || e.target.value > 999999999 || e.key === '-') {
      //   e.preventDefault();
      //   return false;
      // }

      if (e.target.value > 999999999 || e.key === '-') {
        e.preventDefault();
        return false;
      }

      const charCode = (e.which) ? e.which : e.keyCode;
      const number = e.target.value.split('.');

      if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
        return false;
      }

      //just one dot
      if (number.length > 1 && charCode === 46) {
        e.preventDefault();
        return false;
      }
      
      if (e.target.value.length === 0 && charCode === 46) {
        e.preventDefault();
        return false;
      }

      //get the carat position
      const caratPos = e.target.selectionStart;
      const dotPos = e.target.value.indexOf(".");
      if (caratPos > dotPos && dotPos > -1 && (number[1].length > 1)) {
        e.preventDefault();
        return false;
      }
      return true;
    }
  }

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus()
    }
  }, [editing])

  const toggleEdit = () => {
    setEditing(!editing)
    form.setFieldsValue({ [dataIndex]: record[dataIndex] })
  }

  const save = async () => {
    try {
      const values = await form.validateFields()
      toggleEdit()
      handleSave({ ...record, ...values })
    } catch (errInfo) {
      // console.log('Save failed:', errInfo)
    }
  }

  const onPasteText = (e: any, dataIndex: string) => {
    if (dataIndex == "description" || dataIndex == "account") {
      if (specialCharRegexRu.test(e.clipboardData.getData('Text')) || specialCharRegex.test(e.clipboardData.getData('Text'))) {
        e.preventDefault()
        return false
      } else {
        return true
      }
    }


    if (dataIndex == "amount") {
      var pattern = /-/g;
      const pastedText = e.clipboardData.getData('Text');
      var matches = pattern.test(pastedText);
      if(matches){
        e.preventDefault()
        return false
      }
    }
  }

  let childNode = children
  if (editable) {
    childNode = editing ? (
      <Form.Item
        className="editable-form-item"
        name={dataIndex}
      >
        <Input
          ref={inputRef}
          onPressEnter={save}
          rules={rules}
          value={value}
          readOnly={readOnly}
          disabled={disabled}
          onKeyUp={(e) => onKeyPress(e, dataIndex)}
          onKeyPress={(e) => onKeyPress(e, dataIndex)}
          mask={'_'}
          placeholder={placeholder}
          //@ts-ignore
          // type={dataIndex === 'amount' ? "number" : "text"}
          type={"text"}
          onPaste={(e: any) => onPasteText(e, dataIndex)}
          onBlur={save}
          className={(value && value == '') ? 'editable-form-item__input' : `editable-form-item__input editable-form-item__input--bordered borderedgpp`}
          onChange={(e: any, dataIndex: string) => handleInputChange(e, dataIndex)}
          allowClear={true}
        />
      </Form.Item>
    ) : <div onClick={toggleEdit}>
      {children}
    </div>
  }


  return <td {...restProps}>{childNode}</td>
}
export default EditableCell
